import React, { useContext, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import Markdown from "react-markdown";
import { navigate } from "@reach/router";
import { makeStyles } from "@material-ui/styles";
import RequestForm from "./form";
import { AppContext, TOAST } from "../../context";
import { requestPassword } from "../../infrastructure/actions";

let source;

const useStyles = makeStyles({
  container: {
    maxWidth: "1024px",
    width: "100%",
    margin: "16px auto",
    "@media(max-width: 1024px)": {
      margin: "0 auto",
    },
  },
  paper: {
    padding: "16px",
  },
});

const Request = props => {
  const { config } = useSelector(state => ({
    config: state.infrastructure.config,
  }));

  const classes = useStyles();
  const [topText, setTopText] = useState("");
  const [bottomText, setBottomText] = useState("");
  const { dispatch } = useContext(AppContext);
  const rdxDispatch = useDispatch();

  useEffect(() => {
    let CancelToken = axios.CancelToken;
    source = CancelToken.source();
    const url = "/ee-static/members/Texts/RequestPassword";
    axios
      .all([
        axios.get(`${url}/top.md`, {
          cancelToken: source.token,
        }),
        axios.get(`${url}/bottom.md`, {
          cancelToken: source.token,
        }),
      ])
      .then(
        axios.spread((top, bottom) => {
          setTopText(top.data);
          setBottomText(bottom.data);
        })
      )
      .catch(error => {
        if (!axios.isCancel(error)) {
          console.log(error);
        }
      });

    return () => source.cancel("Component Is Unmounting");
  }, []);

  const handleSubmit = (values, actions) => {
    rdxDispatch(
      requestPassword(values.email, response => {
        if (response.status >= 400) {
          const errorMsg =
            response.statusText.length < 1
              ? "E-postadress finns inte i systemet"
              : response.statusText;

          dispatch({
            type: TOAST,
            payload: { text: errorMsg, variant: "error" },
          });
          return actions.setSubmitting(false);
        }
        dispatch({
          type: TOAST,
          payload: { text: "Ett mail har skickats", variant: "success" },
        });
        actions.resetForm();
        navigate(config.self);
      })
    );
  };

  return (
    <div className={classes.container}>
      <Markdown
        source={topText}
        escapeHtml={false}
        skipHtml={false}
        className="request-password__top-text"
      />
      <RequestForm initialValues={{ email: "" }} handleSubmit={handleSubmit} />
      <Markdown
        source={bottomText}
        escapeHtml={false}
        skipHtml={false}
        className="request-password__bottom-text"
      />
    </div>
  );
};

export default Request;
